// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import GoogleIcon from "./GoogleIcon"
import SocialLoginButton from "../SocialLoginButton"
import CreditCard from "modals/CreditCard"
import withMutation from "hoc/withMutation"
import withSubmit from "hoc/withSubmit"
import withConnect from "hoc/withConnect"
import { trackSignup } from "analytics/membership/analyticsTraits"
import { loginGoogleMutation } from "data/user/graphql/mutations"
import { login } from "data/user/actions"
import { openModal } from "data/modals/actions"
import config from "global/config"
import getErrorMessage from "common/graphql/getErrorMessage"
import {
  trackLoginError,
  trackLoginSuccess,
} from "analytics/login/analyticsTraits"

const GoogleLogin = ({ submit, signup }) => {
  if (!config.googleClientId) return null

  return (
    <SocialLoginButton
      provider="google"
      appId={config.googleClientId}
      onLoginSuccess={submit}
      onLoginFailure={console.warn}
      icon={GoogleIcon}
      type="google"
    >
      {signup ? 'Signup with Google' : 'Login with Google'}
    </SocialLoginButton>
  )
}

const mapDispatchToProps = {
  login,
  openModal,
}

type Outter = {|
  close: Function,
  signup?: boolean,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withMutation(loginGoogleMutation),
  withSubmit({
    submit: props => user =>
      props.submitMutation({
        idToken: user.token.idToken,
      }),
    onSuccess: props => res => {
      props.login(res)

      if (props.signup) {
        trackSignup(res)
      } else {
        trackLoginSuccess(res)
      }

      props.close()
      if (props.signup) props.openModal(CreditCard, { type: "add" })
    },
    onError: props => res => {
      const message = getErrorMessage(res)
      trackLoginError(message)
      return message
    },
  }),
)

export default enhancer(GoogleLogin)



// WEBPACK FOOTER //
// ./src/components/SocialLogin/GoogleLogin/index.js